<template>
  <div class="factory-delivery-list">
    <el-row class="factory-delivery-list-title">
      <el-col :span="3">
        <span class="h3">经销商列表</span>
      </el-col>
      <el-col :span="6" :offset="13">
        <div class="factory-delivery-list-title-filter">
          <span class="label">条件搜索：</span>
          <el-input placeholder="请输入经销商名称" v-model="pagination.name" prefix-icon="el-icon-search"
                    @change="loadSearchEnterprise" clearable></el-input>
        </div>
      </el-col>
      <el-col :span="2">
                <span class="btn-add" @click="handleShowEnterpriseCreate"> <i class="iconfont icon-tianjia1"
                ></i> 新增经销商</span>
      </el-col>
    </el-row>

    <div class="factory-delivery-list-data-list">
      <el-table :data="deliveries">
        <el-table-column label="经销商编号" align="center" prop="uuid"></el-table-column>
        <el-table-column label="经销商名称" align="center" prop="name"></el-table-column>
        <el-table-column label="设备总数" align="center" prop="devices"></el-table-column>
        <el-table-column label="账户余额(元)" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.balance | F1000}}</span>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" align="center">
          <template slot-scope="scope">
            <span>{{new Date(scope.row.createdAt * 1000).Format('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cao_zuo')" align="center" min-width="240">
          <template slot-scope="scope">
            <span class="delivery-list-edit">账户充值</span>
            <span class="delivery-list-edit" @click="enterpriseCtrl(scope.row)">代为运营</span>
            <span class="delivery-list-edit" @click="openAllocate(scope.row)">分配设备</span>
            <span class="delivery-list-delete" @click="handleEnterpriseDelete(scope.row, scope.$index)">{{$t('shan_chu')}}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        class="pagination"
        :current-page="pagination.curPage"
        :page-size="pagination.limit"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>


    <c-dialog class="dialog" :visible.sync="addEnterpriseVisible" :width="'25rem'" :height="'18.75rem'"
              title="新增经销商">
      <el-form class="create-product-dialog" label-width="100px">
        <el-form-item label="经销商名称">
          <el-input v-model="delivery.name" placeholder="请输入经销商名称"></el-input>
        </el-form-item>
        <el-form-item label="登录手机号">
          <el-input v-model="delivery.phone" placeholder="请输入登录手机号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="delivery.password" type="string" placeholder="请输入登录密码"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="success" plain @click="handleEnterpriseCreate">{{$t('ti_jiao')}}</el-button>
        </el-form-item>
      </el-form>

    </c-dialog>

    <c-dialog class="dialog" :visible.sync="allocatedVisible" :width="'50rem'" :height="'37.5rem'"
              :outer-close="false"
              title="分配设备">

      <el-button slot="title" size="mini" type="primary" @click="deviceAllocate">{{$t('bao_cun')}}</el-button>

      <allocation-device :close="closeAllocated" ref="allocDevice" slot="default"></allocation-device>
    </c-dialog>

  </div>

</template>

<script>
  import CDialog from '@/components/Dialog'
  import AllocationDevice from './allocationDevice'
  import {checkPhone} from '@/util/checkLogin'
  import {
    enterpriseUnion,
    enterpriseList,
    enterpriseCreate,
    enterpriseCtrl,
    enterpriseDelete
  } from '@/api/factory/account/enterprise'
  import {setToken} from '@/util/auth'

  export default {
    name: '',
    components: {
      CDialog,
      AllocationDevice
    },
    mounted: function () {
      this.loadEnterprise()
    },
    computed: {},
    data: function () {
      return {
        deliveries: [],
        addEnterpriseVisible: false,
        allocatedVisible: false,
        pagination: {
          name: '',
          start: 0,
          curPage: 1,
          limit: 10,
          total: 0,
        },
        delivery: {
          name: '',
          phone: '',
          password: ''
        }

      }
    },
    filters: {},
    methods: {
      handleShowEnterpriseCreate() {
        this.delivery = {
          name: '',
          phone: '',
          password: ''
        }
        this.addEnterpriseVisible = true
      },
      handleEnterpriseCreate() {
        let vue = this
        if (this.delivery.name.length === 0) {
          this.$message.error('请输入经销商名称')
          return
        }
        let res = checkPhone(this.delivery.phone)
        if (!res.status) {
          this.$message.error(res.msg)
          return
        }

        if (this.delivery.password.length === 0) {
          this.$message.error('请输入登录密码')
          return
        }


        enterpriseCreate(this.delivery).then(() => {
          vue.$message.success('添加成功')
          vue.addEnterpriseVisible = false
          vue.pagination.name = ''
          vue.loadSearchEnterprise()
        })
      },
      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        enterpriseList(this.pagination).then(res => {
          this.deliveries = res.data
        })
      },
      loadSearchEnterprise() {
        this.pagination.start = 0
        this.pagination.curPage = 1
        this.loadEnterprise()
      },
      loadEnterprise() {
        let vue = this
        enterpriseUnion(this.pagination).then(res => {
          if (res !== null && res.code === 0) {
            vue.deliveries = res.data.list || []
            vue.pagination.total = parseInt(res.data.total)
          }
        })
      },

      handleEnterpriseDelete(row, idx) {
        this.$confirm('此操作将企业数据切不可恢复，是否继续', this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('qu_xiao'),
          type: 'warning'
        }).then(() => {
          enterpriseDelete({uuid: row.uuid}).then(res => {
            this.$message.success('删除成功')
            this.deliveries.splice(idx, 1)
          })
        }).catch(() => {

        })
      },
      closeAllocated() {
        this.allocatedVisible = false
      },
      openAllocate(enterprise) {
        let vue = this
        this.allocatedVisible = true
        setTimeout(function () {
          vue.$refs.allocDevice.setEnterprise(enterprise)
        }, 200)
      },

      enterpriseCtrl(delivery) {
        enterpriseCtrl({uuid: delivery.uuid}).then(res => {
          setToken(res.data)
          window.location.href = "/"
        })
      },
      deviceAllocate() {
        let vue = this
        vue.$refs.allocDevice.deviceAllocate()
      }
    },
  }
</script>

<style lang="scss">
  .factory-delivery-list {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .factory-delivery-list-title {
      margin-bottom: $padding;

      .factory-delivery-list-title-filter {
        display: flex;
        justify-content: center;
        align-items: center;

        .label {
          display: inline-block;
          width: 5rem;
          font-size: .6rem;
          color: $f_sec_color;
          text-align: right;
        }
      }

      .el-input {
        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }

        .el-input__icon {
          line-height: 24px;
        }
      }

      .btn-add {
        margin-left: $padding-5;
        color: $f_color;
        font-size: .6rem;
        padding: $padding-3;
        border-radius: .3rem;
        cursor: pointer;
      }

      .btn-add:hover {
        background-color: $bg_six_color;
        font-weight: $w1;
      }
    }

    .factory-delivery-list-data-list {
      flex: 1;
      border-radius: .5rem;
      // background-color: $bg_sec_color;
      padding: $padding;

      .delivery-list-edit, .delivery-list-delete {
        cursor: pointer;
        display: inline-block;
        margin-right: $padding;
      }

      .delivery-list-edit {
        color: $btn_color;
      }

      .delivery-list-delete {
        color: $btn_sec_color;
      }

      .pagination {
        margin-top: $padding;
      }

      .default {
        font-size: .6rem;
        background-color: $f_50_color;
        padding: 2px 4px;
        border-radius: 2px;
      }
    }

    .dialog {

      .version-dialog {
        padding: 0 $padding;

        .el-form-item__label {
          color: $f_sec_color;
        }

        .el-textarea__inner, .el-input__inner {
          border-color: $bg_999_color;
          color: $f_color;
        }

        .el-upload-dragger {
          background-color: transparent;
        }

        .el-textarea__inner {
          font-size: .6rem;
        }

        .el-button {
          color: $f_color;
        }

        .version-dialog-body {
          padding: 0 $padding;

          .el-input, .el-textarea {
            width: 218px;
          }

          .base-info, .ctrl-info {
            float: left;
            width: 50%;
          }
        }

        .hidden {
          .el-upload-dragger {
            display: none;
          }
        }

        .el-upload {
          width: 100%;

          .el-upload-dragger {
            width: 100%;
          }
        }

        .dialog-commit-btn {
          text-align: center;
        }
      }
    }
  }

</style>
